<div class="flex items-center space-x-2">
  <span class="text-base text-aux-gray-darkest">
    {{ params.displayName }}
  </span>

  @if (patientGroupsColumns.length) {
    <button class="aux-link flex items-center no-underline" (click)="onChangeClick()">
      <aux-icon
        class="text-aux-gray-darkest"
        [name]="(change$ | async) ? 'ChevronLeft' : 'ChevronRight'"
      />
    </button>
  }
</div>
